module.exports = __webpack_public_path__ + "static/media/team1.a8b796ba.webp";